<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="full-height" v-loading="loading">
      <fieldset class="margin-top-2 padding-1">
        <legend>用户信息</legend>
      <el-form :model="basicsForm" ref="form" label-position="top" :rules="rules">
        <el-row>
         <!-- <el-col :lg="8" :sm="12">
            <el-form-item label="企业名称" prop="cliEntName" required>
              <el-input v-model="basicsForm.cliEntName"/>
            </el-form-item>
          </el-col>-->
          <el-col :lg="6" :sm="12">
            <el-form-item label="传输身份(DXPID)" prop="cliEntDxpid" required>
              <el-input v-model="basicsForm.cliEntDxpid" />
            </el-form-item>
          </el-col>
        <el-col :lg="6" :sm="12">
          <el-form-item label="IC卡密码" prop="cliEntIcpw">
            <el-input v-model="basicsForm.cliEntIcpw" show-password >
              <el-button slot="append" @click="checkUkey()" icon="el-icon-search">验证</el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :sm="12">
          <el-form-item label="IC卡号 (IC卡密码验证通过后可自动填充)" prop="cliEntIcno">
            <el-input v-model="basicsForm.cliEntIcno" />
          </el-form-item>
        </el-col>
          <el-col :lg="6" :sm="12">
            <el-form-item label="最后编辑时间" prop="cliOpTime" >
              <el-date-picker v-model="basicsForm.cliOpTime" type="datetime"  disabled> </el-date-picker>
            </el-form-item>
          </el-col>
      </el-row>
      </el-form>
      </fieldset>
    <el-row>
      <el-col :lg="8" :sm="12" >
<!--        style="height: calc(100vh - 337px)"-->
        <Panel title="传输配置"  class="margin-top-2"  >
          <template slot="buttons">
            <el-select v-model="cliConnType" placeholder="请选择" @change="transTypeChange" clearable>
              <el-option
                v-for="item in transTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value" >
              </el-option>
            </el-select>
          </template>
          <IBMMQConfig v-if="iBMMQConfigArrt.show" v-model="iBMMQConfigArrt.data" ref="ibmmqRef"></IBMMQConfig>
          <RabbitMQConfig v-if="rabbitMQConfigArrt.show" v-model="rabbitMQConfigArrt.data" ref="rmqRef" style="height: 312px"></RabbitMQConfig>
        </Panel>
      </el-col>

      <el-col :lg="16" :sm="12" >
        <Panel title="本地配置" class="margin-top-2" >
          <template slot="buttons">
            <el-button title="新增本地配置" icon="el-icon-plus" @click.stop="fastAddData">新增</el-button>
          </template>
            <PageTable hideTitle hideExport ref="dataTable" :data="dataTable" @load-data="dataTableLoad" highlight-current-row stripe border :height="tableHeigth" pageSize="10">
            <el-table-column prop="cliBizUuid" label="业务类型" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-select filterable placeholder="业务类型" v-model="scope.row.cliBizUuid" v-if="scope.row.isEdit">
                  <el-option
                    v-for="item in cliBizType"
                    :key="item.biz_name"
                    :label="item.biz_name + ' - [ ' + item.biz_dxpid + ' ]'"
                    :value="item.uuid" >
                  </el-option>
                </el-select>
                <el-select filterable placeholder="业务类型" v-model="scope.row.cliBizUuid" disabled v-if="!scope.row.isEdit">
                  <el-option
                    v-for="item in cliBizType"
                    :key="item.biz_name"
                    :label="item.biz_name"
                    :value="item.uuid" >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="cliOutDir" label="业务申报本地路径" show-overflow-tooltip>
              <template slot-scope='scope'>
                <span v-if="!scope.row.isEdit">{{scope.row.cliOutDir}}</span>
                <el-input v-if='scope.row.isEdit' v-model="scope.row.cliOutDir" maxlength='100' />
              </template>
            </el-table-column>
            <el-table-column prop="cliInDir" label="回执接收本地路径" show-overflow-tooltip>
              <template slot-scope='scope'>
                <span v-if="!scope.row.isEdit">{{scope.row.cliInDir}}</span>
                <el-input v-if='scope.row.isEdit' v-model="scope.row.cliInDir" maxlength='100' />
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed='right' width="120" align="center">
              <template slot-scope="scope">
                <el-button v-if='!scope.row.isEdit' type="primary" icon="el-icon-edit" title="修改" @click="fastEditData(scope.row)">修改</el-button>
                <el-button v-if='scope.row.isEdit' type="primary" icon="el-icon-fa-save" title="确认" @click="fastConfirm(scope.row)">确认</el-button>
                <el-button v-if='scope.row.isEdit' icon="el-icon-close" title="取消" @click="fastCancel(scope.$index,scope.row)">取消</el-button>
                <el-button v-if='!scope.row.isEdit' icon="el-icon-delete" title="删除" @click="fastDelete(scope.$index ,scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </PageTable>
        </Panel>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import EasyConfigApi from "@/api/basics/EasyConfigApi";// 配置页面
import  IBMMQConfig from "./IBMMQConfig.vue";
import  RabbitMQConfig from "./RabbitMQConfig.vue";
import BizChainApi from "../rsrcmgr/bizchain/BizChain";
import {config} from "cnetong-core-frontend";
import CommonValidate from "@/libs/Validate";

//默认数据
let defaultFormData = {
  uuid:"",
  cliEntName: "",
  cliEntDxpid: "",
  cliEntIcno: "",
  isEdit: true
};

export default {
  name: "EasyConfig",
  components: { IBMMQConfig, RabbitMQConfig },
  computed: {},
  data() {
    return {
      EasyConfigApi,
      loading: false,
      basicsForm: {
        cliEntName:"",
        cliEntDxpid:"",
        ukeyPassword:"",
        cliEntIcno:"",
      },
      dataTable: [],
      startTimeOption: {},
      endTimeOption: {},
      cliBizType:[],
      transTypeOptions: [{
        value: 'wmq',
        label: 'IBMMQ'
      }, {
        value: 'rmq',
        label: 'RabbitMQ'
      }],
      iBMMQConfigArrt:{
        show:false,
        data:{}
      },
      rabbitMQConfigArrt:{
        show:false,
        data:{}
      },
      cliConnType: "rmq",
      //快速编辑备份
      copyData: null,
      rules: {
        // cliEntName: [{ required: true, message: "这是必填字段" }],
        cliEntDxpid: [{ required: true, message: "这是必填字段" },
          {validator: CommonValidate.checkSpecificKey, trigger: ["blur", "change"]},
          {min: 1, max: 50, message: "长度在 1 到 30 个字符以内", trigger: "blur"}],
        // cliEntIcno: [{ required: true, message: "这是必填字段" }],
      },
      tableHeigth:"286px",
    };
  },
  async mounted() {
    this.$refs.dataTable.load();
    BizChainApi.selectBizChain({}).then(resp=>{
        this.cliBizType = resp.datas;
      });
  },
  methods: {
    refushform(){
      this.dataTableLoad();
    },
    refush(){
      this.$refs.dataTable.load();
    },
    // 保存基础信息
    async saveBasics() {
      await this.$refs.form.validate();
      this.basicsForm.cliConnType = this.cliConnType
      if(this.cliConnType === 'rmq' ){
        await this.$refs.rmqRef.validate();
        this.basicsForm.cliConnConf = this.rabbitMQConfigArrt.data;
      }else if(this.cliConnType === 'wmq' ){
        await this.$refs.ibmmqRef.validate();
        this.basicsForm.cliConnConf =this.iBMMQConfigArrt.data;
      }
      try {
        this.$confirm("停止所有业务监听，并保存？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.loading = true;
          EasyConfigApi.saveBasics(this.basicsForm).then(resp=>{
            this.dataTableLoad();
            this.$emit('refresh');
            this.loading = false;
          });
        });
      }catch (e) {
        this.loading = false;
      }
    },
    // 传输类型下拉选更改
    transTypeChange(type){
      if(type=='wmq'){
        this.iBMMQConfigArrt.show = true;
        this.rabbitMQConfigArrt.show = false;
      }else{
        this.rabbitMQConfigArrt.show = true;
        this.iBMMQConfigArrt.show = false;
      }
    },
    // 加载表格数据
    dataTableLoad(params, resolve) {
      EasyConfigApi.doQuery(params)
        .then(resolve) // 让表格解析你提供的数据 (主要解析页码等)
        .then(respData => {
          this.cliConnType = 'rmq';
          if(respData.identity){
            this.basicsForm = respData.identity;
            this.cliConnType = respData.identity.cliConnType;
            if(this.cliConnType===null){
              this.cliConnType = 'rmq';
            }
            if(respData.identity.cliConnType === 'wmq' ){
              this.iBMMQConfigArrt.data = JSON.parse(respData.identity.cliConnConf);
            }else if(respData.identity.cliConnType === 'rmq' ){
              this.rabbitMQConfigArrt.data = JSON.parse(respData.identity.cliConnConf);
            }
          }
          this.transTypeChange(this.cliConnType);
          if(respData.datarows){
            let datarows = [];
            for(let row in respData.datarows) {
              respData.datarows[row].isEdit = false;
              datarows.push(row)
            }
            this.dataTable = respData.datarows;
          }
        });
    },
    //验证IC卡环境 成功的话 自动填充IC卡号
    checkUkey(){
      if(this.basicsForm.cliEntIcpw && this.basicsForm.cliEntIcpw!==undefined){
        try {
          this.loading = true;
          EasyConfigApi.ukeycheck(this.basicsForm.cliEntIcpw).then(resp=>{
            this.basicsForm.cliEntIcno = resp.icno;
            this.loading = false;
          });
        }catch (e) {
          this.loading = false;
          this.$message.error(e.respCode);
        }
      }else{
        this.$message.error("请填写ukey/ic卡密码！");
        return;
      }
    },
    //-----------------------表格快速编辑开始---------------------------------
    // 快速添加数据
    fastAddData() {
      if(!this.basicsForm.uuid){
        this.$message.error("请先保存用户信息,然后再新增本地配置信息！");
        return;
      }else{
        EasyConfigApi.handleAddBeforCheck(this.basicsForm.uuid).then(resp=>{
          if(resp.respCode!=="000000"){
            this.$message.error(resp.respDesc);
            return;
          }
          this.dataTable.push(Object.assign({}, defaultFormData));
        });
      }
    },
    checkSpecialKey(str) {
      var specialKey = "[`~!#$^&*()=|{}';'[].<>?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
      for (var i = 0; i < str.length; i++) {
        if (specialKey.indexOf(str.substr(i, 1)) != -1) {
          return false;
        }
      }
      return true;
    },
    // 快速编辑
    fastEditData(row) {
      this.copyData = Object.assign({}, row);
      row.isEdit = true;
    },
    //确认提交
    async fastConfirm(row) {
      if (!row.cliBizUuid || !row.cliOutDir || !row.cliInDir) {
        this.$message.error("请补全数据!");
        return;
      }
      if(!this.checkSpecialKey(row.cliOutDir)){
        this.$message.error("不允许输入特殊字符!");
        return;
      }
      if(!this.checkSpecialKey(row.cliInDir)){
        this.$message.error("不允许输入特殊字符!");
        return;
      }
      try {
        // 保存之前的业务检查
        await EasyConfigApi.saveLocalInfoBefor(this.basicsForm.uuid,row.cliBizUuid);
        this.loading = true;
        row.cliEntUuid = this.basicsForm.uuid;
        await EasyConfigApi.handleSaveLocalInfo(row);
        row.isEdit = false;
        this.copyData = null;
        this.$refs.dataTable.load();
        this.$emit('refresh');
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.$message.error(e.respCode);
      }
    },
    //取消提交
    fastCancel(index, row) {
      if (this.copyData) {
        Object.assign(row, this.copyData);
        this.copyData = null;
      } else {
        this.dataTable.splice(index, 1);
      }
    },
    //删除记录
    async fastDelete(index, row) {
      if (row.uuid) {
        await EasyConfigApi.handleDeleteLocalInfo(row.uuid);
        this.$refs.dataTable.load();
        this.$emit('refresh');
      } else {
        this.dataTable.splice(index, 1);
      }
    },
    //-----------------------表格快速编辑结束---------------------------------
    // 导入
    importConfig(){

    },
    // 导出
    exportConfig(){
      if(!this.basicsForm.uuid){
        this.$message.error("请先完善用户信息！");
        return;
      }
      var url =
        config.ajaxUrl + "/aseapi/console/Basics/exportConfig";
      //创建form
      var temp = document.createElement("form");
      temp.id = "tempForm1";
      temp.action = url;
      //get请求
      temp.method = "get";
      //创建input
      var opt = document.createElement("input");
      opt.name = "uuid";
      //input传uuid
      opt.value = this.basicsForm.uuid;
      temp.appendChild(opt);
      //隐藏form
      temp.style.display = "none";
      document.body.appendChild(temp);
      //提交表单
      temp.submit();
      //移除
      document.body.removeChild(temp);
    },
    getConnTypeName(uuid){
      let bizType = this.cliBizType.find(uuid);
      return bizType.name;
    },
  },
};
</script>
